<template>
	<el-config-provider :locale="elementLang">
		<div id="main-app" v-loading="loading">
			<!-- 裸路由（登录/404/403/AI页面） -->
			<router-view v-if="getRouteMode() === 'none'"></router-view>
			<!-- 商城布局 -->
			<MallLayout v-else-if="getRouteMode() === 'mall'">
				<router-view v-slot="{ Component }">
					<component :is="Component" v-if="!$route.meta.keepAlive" :key="$route.name" />
					<keep-alive v-if="$route.meta.keepAlive">
						<component :is="Component" :key="$route.name" />
					</keep-alive>
				</router-view>
			</MallLayout>
			<!-- 后台管理布局 -->
		</div>
	</el-config-provider>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import MallLayout from '@/views/mall/layout/index.vue'
import { isMobileDevice } from '@/utils/util'
import { setLang } from '@/utils/util'
import website from '@/config/website'
import { getLangData as getLangConfigApi } from '@/api/common'
import useStore from '@/store'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import th from 'element-plus/es/locale/lang/th'
import { MALL_ROUTE_PREFIXES } from '@/router/mall'
import { mobileRedirectUrl } from '@/config/env'

const loading = ref(false)
const route = useRoute()
const router = useRouter()
const { userStore } = useStore()
const { language } = userStore

const elementLang: any = ref(null)

// 路由渲染模式：none（裸路由）/ mall（商城布局）/ admin（后台布局）
const getRouteMode = () => {
	const noLayoutRoutes = ['/403', '/404', '/aiHome', '/aiDialogue', '/aiNewsDetails', '/agentList']
	if (noLayoutRoutes.includes(route.path)) return 'none'
	if (MALL_ROUTE_PREFIXES.some((p: string) => route.path.startsWith(p))) return 'mall'
	return 'admin'
}
// PC路由 → 移动端页面对应关系（url：移动端页面地址，type/id：data 参数值）
interface MobileRouteTarget {
	url: string
	type: string
	id: string
}
// 根据当前PC路由拼接移动端跳转链接：移动端链接?url=移动端路由&data={type,id}
const buildMobileRedirectUrl = (): string => {
	const paramsId = typeof route.params.id === 'string' ? route.params.id : ''
	const routeName = typeof route.name === 'string' ? route.name : ''
	const routeMap: Record<string, MobileRouteTarget> = {
		mallHome: { url: 'pages/home/homePage', type: '1', id: '' },//首页
		mallCategory: { url: 'pages/home/homePage', type: '2', id: paramsId },//分类
		mallProductDetail: { url: `pages/goods/detail`, type: '', id: paramsId },//商品详情
		mallProfile: { url: 'pages/home/homePage', type: '4', id: '' },//个人中心
		mallAbout: { url: 'pages/about/index', type: '', id: '' },//关于我们
		mallNewsDetail: { url: `pages/home/articleDetail`, type: '', id: paramsId }//新闻详情
	}
	const target = routeMap[routeName]
	// 未匹配的路由（购物车/订单/登录等）仍跳移动端首页
	if (!target) return mobileRedirectUrl
	const data = JSON.stringify({ url: target.url, type: target.type, id: target.id })
	const separator = mobileRedirectUrl.includes('?') ? '&' : '?'
	return `${mobileRedirectUrl}${separator}data=${encodeURIComponent(data)}`
}

onMounted(async () => {
	// 路由初始导航是异步的，刷新页面时需等待 isReady 后才能拿到 route.name/params
	await router.isReady()
	console.log(buildMobileRedirectUrl())
	// 移动端访问跳转到移动端站点（携带当前页面对应的移动端路由和参数）
	if (isMobileDevice() && mobileRedirectUrl) {
		window.location.replace(buildMobileRedirectUrl())
		return
	}
	//加载多语言数据
	getLangData()
	// 获取多语言配置列表（供语言切换组件复用，避免重复请求）
	getLangConfigApi({ id: website.buId }).then((res: any) => {
		if (res.code == 200) {
			userStore.setLangConfigList(res.data.langConfigList || [])
		}
	})
	// 根据当前语言设置对应货币：zh→人民币，其他→美元
	userStore.setCurrencyByLanguage(language)
})

const getLangData = async () => {
	// if (isDev) return
	loading.value = true
	await setLang()
	// document.title = i18n.t(website.lankeyPrefix + 'sysTitle')
	if (language == 'zh') {
		elementLang.value = zhCn
	} else if (language == 'en') {
		elementLang.value = en
	} else if (language == 'th') {
		elementLang.value = th
	}
	loading.value = false
}
</script>

<style lang="scss">
@import 'style/index';
#nprogress .bar {
	background: #f92863 !important;
}
#nprogress .peg {
	box-shadow:
		0 0 10px #f92863,
		0 0 5px #f92863 !important;
}
</style>
